// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

import PropTypes from 'prop-types';

// The intent here is to stay "in sync" with https://ghe.coxautoinc.com/DDC-WebPlatform/cms-web/blob/master/htdocs/common/item-lists/ws-staff-listing-schema.xml
export const StaffMemberShape = {
	entityComponentClassName: PropTypes.string,
	department: PropTypes.string,
	email: PropTypes.string,
	name: PropTypes.string.isRequired,
	phone: PropTypes.string,
	photo: PropTypes.string,
	status: PropTypes.string.isRequired,
	title: PropTypes.string,
	bio: PropTypes.string,
	badges: PropTypes.string
};

export const labelConstants = {
	CIRCLE: 'circle',
	SQUARE: 'square'
};
